// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2uRVM","name":"Header_name__2qzrB","birthday":"Header_birthday__2NjuL","skeleton":"Header_skeleton__1I2g5"};